import React, { Component } from "react";
import { connect } from "react-redux";
import { FilePond } from "react-filepond";
import { withRouter } from "react-router-dom";
import "filepond/dist/filepond.min.css";
import { Loader } from "@revvsales/components";

// Service Import
import { uploadPDF } from "../../actions/DocumentActions/services";

// Internal Imports
import { GlobalUtils } from "../../utils";
import { PATHS } from "../../constants";
import UPLOAD_FORMAT_IMG from "../../assets/upload-format.svg";

// Destructuring
const { writeDataToLocalStorage } = GlobalUtils;

class QuotationUpload extends Component {
  state = {
    fileDetails: { name: null, size: 0 },
  };

  constructor(props) {
    super(props);
    this.filePond = React.createRef();
  }

  _uploadPDF = data => {
    const payload = {
      data,
      folderId: this.props.currentFolderID || null,
    };
    uploadPDF(payload)
      .then(res => {
        writeDataToLocalStorage("documentPageSource", "assets");
        this.props.history.push(`${PATHS.DOCUMENTS_PATH}/${res}`);
      })
      .catch(err => {
        this.props.setDoc({
          error:
            "File is too large to upload. Upload PDF or docx of 50MB or lesser.",
        });
        console.error(`QuotationUpload => _uploadPDF => ${err}`);
      });
  };

  updateFile = fileItems => {
    const fromDocPage = this.props.page === "DOCUMENT";
    fileItems = this.filePond.current.getFiles();
    if (Object.keys(fileItems).length !== 0) {
      if (fromDocPage && fileItems[0].fileExtension === "pdf") {
        this._uploadPDF(fileItems[0].file);
      } else if (fileItems[0].fileExtension === "docx") {
        if (
          !(
            fileItems[0].filename === this.state.fileDetails.name &&
            fileItems[0].fileSize === this.state.fileDetails.size
          )
        ) {
          const fileDetails = fileItems[0].file;
          this.props.setDoc({ fileDetails });
        } else {
          const fileDetails = { name: null, size: 0 };
          this.props.setDoc({ fileDetails });
        }
      } else {
        this.props.setDoc({
          error: fromDocPage
            ? "Only PDF and docx files are supported."
            : "Only .docx file is supported",
        });
      }
    }
  };

  _progressIndicator = () => {
    const { uploaded } = this.props;
    if (uploaded === false) {
      return <Loader className="file-uploading" label="Uploading..." />;
    }
    return null;
  };

  render() {
    const fromDocPage = this.props.page === "DOCUMENT";
    const label = fromDocPage
      ? `<img src=${UPLOAD_FORMAT_IMG}></img><div>Drag & drop .docx or .pdf files or <u>browse</u> to upload</div>`
      : "Drag & drop a .docx file or <u>browse</u> to upload";
    return (
      <div className={fromDocPage ? "quotationupload-doc" : ""}>
        <FilePond
          allowMultiple={false}
          ref={this.filePond}
          labelIdle={label}
          onaddfile={() => this.updateFile()}
        />
      </div>
    );
  }
}
const mapStateToProps = ({ AssetStore: { currentFolderID } }) => ({
  currentFolderID,
});
export default connect(mapStateToProps)(withRouter(QuotationUpload));



// WEBPACK FOOTER //
// ./src/components/QuotationUpload/QuotationUpload.js